/* eslint-disable import/prefer-default-export */
import { TranslationMapMessages, MapMessages } from "../interfaces";

export const messages: TranslationMapMessages = {
  [MapMessages.updateVehicleCurrentPosition]: "Atualize a posição atual do veículo",
  [MapMessages.errorFetchingAddressData]: "Erro ao buscar dados de endereço",
  [MapMessages.locationSearchTitle]: "Busca de localização",
  [MapMessages.typeLocationLabel]: "Digite a localização",
  [MapMessages.allVehiclesSearchLabel]: "Busca por placa, descrição ou cód.",
  [MapMessages.addressSearchLabel]: "Busca por endereço",
  [MapMessages.route]: "Rota",
  [MapMessages.outwardTrip]: "Ida",
  [MapMessages.returnTrip]: "Volta",
  [MapMessages.names]: "Nomes",
  [MapMessages.licensePlates]: "Placas",
  [MapMessages.alerts]: "Alertas",
  [MapMessages.states]: "Estados",
  [MapMessages.events]: "Eventos",
  [MapMessages.viewLocation]: "Visualizar localização",
  [MapMessages.zmrc]: "ZMRC",
  [MapMessages.invalidPolygon]: "Polígono inválido",
  [MapMessages.point]: "Ponto",
  [MapMessages.stopped]: "parado",
  [MapMessages.distanceToConstruction]: "Distância da obra",
  [MapMessages.showOnMap]: "Mostrar no mapa",
  [MapMessages.areas]: "Áreas",
  [MapMessages.construction]: "Obra",
  [MapMessages.constructionNotLocked]: "Obra ainda sem local fixo",
  [MapMessages.invoiceAddress]: "Endereço da nota",
  [MapMessages.plant]: "Usina",
  [MapMessages.trustedLocation]: "Local confiável",
  [MapMessages.discharges]: "Descargas",
  [MapMessages.dischargeInConstruction]: "Descarga na obra",
  [MapMessages.dischargeOutsideConstruction]: "Descarga fora da obra",
  [MapMessages.alertTag]: "Alerta",
  [MapMessages.eventTag]: "Evento",
  [MapMessages.stateTag]: "Estado",
  [MapMessages.legendHint]: "Alerta (vermelho) indica algo a verificar; evento é só informativo.",
  [MapMessages.legendOrderHint]: "Os números marcam o que aconteceu na viagem, na ordem da linha do tempo.",
  [MapMessages.timeline]: "Linha do tempo",
  [MapMessages.replayPlay]: "Reproduzir trajeto",
  [MapMessages.replayPause]: "Pausar",
  [MapMessages.travelMoment]: "Momento da viagem",
  [MapMessages.playbackSpeed]: "Velocidade da reprodução",
  [MapMessages.replayFromHere]: "Reproduzir a partir daqui",
  [MapMessages.replayHint]: "Botão direito no trajeto: reproduzir a partir daquele ponto.",
  [MapMessages.fullscreen]: "Tela cheia",
  [MapMessages.exitFullscreen]: "Sair da tela cheia",
  [MapMessages.fullscreenHint]: "Tela cheia: mapa, replay, linha do tempo e dados da viagem lado a lado. A melhor forma de analisar como foi a viagem.",
  [MapMessages.automaticTravel]: "Viagem automática (sem nota): nenhuma obra reconhecida nesta viagem",
  [MapMessages.automaticConstruction]: "obra automática",
  [MapMessages.travelTime]: "Tempo de viagem",
  [MapMessages.fromConstruction]: "da obra",
  [MapMessages.constructionHelp]: "Ponto da obra e o raio usado para Em obra e Descarregando.\nCheio: as descargas já confirmaram o local e ele ficou fixo.",
  [MapMessages.constructionNotLockedHelp]: "O ponto ainda acompanha as descargas: pode mudar nas próximas entregas até elas confirmarem o local.",
  [MapMessages.invoiceAddressHelp]: "Onde o endereço da nota cai no mapa.\nÉ só referência: a obra é o círculo amarelo.",
  [MapMessages.plantHelp]: "Usina de onde a viagem saiu e para onde voltou.",
  [MapMessages.trustedLocationHelp]: "Local cadastrado, como oficina, posto ou estacionamento.\nEnquanto o caminhão está nele, o estado é Em local confiável.",
  [MapMessages.dischargeInConstructionHelp]: "Ponto em que a descarga foi registrada dentro da obra.",
  [MapMessages.dischargeOutsideConstructionHelp]: "Ponto em que a descarga foi registrada fora da obra.\nGera o alerta de descarregamento indevido.",
  [MapMessages.addressSearchLoading]: "Buscando endereços...",
  [MapMessages.addressSearchUnavailable]: "Não foi possível buscar o endereço agora. Tente novamente ou digite as coordenadas (latitude, longitude)."
};
